import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface EmissionsLedgerState {
    data: [] | null | any;
    totalRecords: number | null;
    totalPages: number | null;
}

const initialState: EmissionsLedgerState = {
    data: null,
    totalRecords: null,
    totalPages: null,
};

export const emissionsLedgerSlice = createSlice({
    name: 'EmissionsLedger',
    initialState,
    reducers: {
        setEmissionsLedger: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const { setEmissionsLedger, reset } = emissionsLedgerSlice.actions;
export const getAllEmissionsLedgerDetails = (state: RootState) => state.emissionsLedger.data;
export const getEmissionsLedgerTotalRecords = (state: RootState) => state.emissionsLedger.totalRecords;
export default emissionsLedgerSlice.reducer;
